import { render } from "./SamenVanWaarde.vue?vue&type=template&id=0c90fcd1&scoped=true"
import script from "./SamenVanWaarde.vue?vue&type=script&lang=js"
export * from "./SamenVanWaarde.vue?vue&type=script&lang=js"

import "./SamenVanWaarde.vue?vue&type=style&index=0&id=0c90fcd1&lang=scss&scoped=true"

import exportComponent from "/Users/Sacha/Projects/muziekdichtbij/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0c90fcd1"]])

export default __exports__